// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import Layout from '../components/Layout';
import TextHeader1 from '../components/TextHeader1';
import TextStrong from '../components/TextStrong';
import TextParagraph from '../components/TextParagraph';
import type { TProps } from './types';
import Container from '../components/Container';
import ButtonBlock from '../components/ButtonBlock';

import successImage from '../assets/images/results-success.png';
import errorImage from '../assets/images/results-error.png';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import toProperCase from '../utils/toProperCase';


function Results(props: TProps): React.Node {
  if (!props.navigation.current.state) return null;

  const {
    error,
    data,
    success_next_path,
    success_next_path_state,
  } = props.navigation.current.state;

  const public_account_token = data.public_account_token;
  const onContinue = () => {
    if (success_next_path && success_next_path_state) {
      const { accounts, account_id } = success_next_path_state;
      props.navigateTo(success_next_path, {
        ...success_next_path_state,
        accounts: accounts.map((account) => (
          account.id === account_id
            ? account.set_public_account_token(public_account_token)
            : account
        )),
      });
    } else {
      props.dispatchEvent(
        EVENT_TYPES.success,
        data,
        () => props.dispatchEvent(EVENT_TYPES.exit, {}, props.async_delete_link_token),
      );
    }
  }

  return (
    <Layout {...props} showLogo padded showExit={!public_account_token}>
      <Container flex centered my={30}>
        <img style={{ maxWidth: 80 }} alt="result" src={public_account_token ? successImage : errorImage} />
      </Container>
      <TextHeader1 centered>
        <TextStrong extra>
          {error ? toProperCase(error.sub_type.replace(/_/g, ' ')) : 'Success'}
        </TextStrong>
      </TextHeader1>
      <TextParagraph centered>
        {error ? error.message : `Your account has been successfully linked with ${props.config.team_name || ''}.`}
      </TextParagraph>
      <Container absolute width="calc(100% - 48px)" bottom={0} left={0} pa={24} fill="white" zIndex={100}>
        <ButtonBlock primary onClick={error ? props.navigateBack : onContinue}>
          {error ? 'Try again' : 'Continue'}
        </ButtonBlock>
      </Container>
    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(Results, { name: 'Results' });
